import CommonHttp from './common-http';

class CommonHttpFactory {
    constructor($http, $q) {
        this.$http = $http;
        this.$q = $q;
    }

    createCommonHttp(config, httpCache) {
        return new CommonHttp(
            this.$http,
            this.$q,
            config || {},
            httpCache
        );
    }
}

CommonHttpFactory.$inject = ['$http', '$q'];

export default CommonHttpFactory;
